// Keep the accessibility and chat launchers above the visible privacy banner.
(() => {
  const bannerSelector = '.cc-window.cc-banner';
  const banners = new Set();
  let frame = 0;
  let previousOffset = -1;

  function scheduleUpdate() {
    if (!frame) frame = requestAnimationFrame(update);
  }

  const resizeObserver = new ResizeObserver(scheduleUpdate);

  function update() {
    frame = 0;

    // Preserve the existing accessibility control's body-level placement.
    const accessibility = document.getElementById('usntA40Toggle');
    if (accessibility && document.body.firstChild !== accessibility) {
      document.body.prepend(accessibility);
    }

    for (const banner of banners) {
      if (!banner.isConnected || !banner.matches(bannerSelector)) {
        resizeObserver.unobserve(banner);
        banners.delete(banner);
      }
    }
    document.querySelectorAll(bannerSelector).forEach(banner => {
      if (!banners.has(banner)) {
        banners.add(banner);
        resizeObserver.observe(banner);
      }
    });

    let offset = 0;
    for (const banner of banners) {
      const style = getComputedStyle(banner);
      const rect = banner.getBoundingClientRect();
      if (banner.hidden || banner.classList.contains('cc-invisible') ||
          style.display === 'none' || style.visibility === 'hidden' ||
          Number(style.opacity) === 0 || !banner.getClientRects().length ||
          rect.height <= 0 || rect.bottom <= 0 || rect.top >= window.innerHeight) continue;
      offset = Math.max(offset, Math.ceil(window.innerHeight - Math.max(0, rect.top)));
    }

    if (offset !== previousOffset) {
      document.documentElement.style.setProperty('--privacy-banner-offset', `${offset}px`);
      previousOffset = offset;
    }
  }

  // Clarip and the launchers may be inserted after the theme has loaded.
  const mutationObserver = new MutationObserver(scheduleUpdate);
  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden']
  });
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  document.addEventListener('transitionend', scheduleUpdate, true);
  scheduleUpdate();
})();
